import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';

import { useInvoiceContext } from '../invoice.context';
import { InformationTabLoadingComponent } from './tabs/information-tab/information-tab-loading.component';
import { InformationTabComponent } from './tabs/information-tab/information-tab.component';

export const InvoiceDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const invoice = useInvoiceContext();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  // Nothing to do

  // HANDLERS //////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  if (!invoice) {
    return <InformationTabLoadingComponent />;
  }

  return (
    <Stack gap={GapEnum.XL} direction="column" flex={1}>
      <InformationTabComponent />
    </Stack>
  );
};
